import React from 'react';
import TextField from '@material-ui/core/TextField';
import styles from './styles';

const CustomTextField = ({
    label,
    ...custom
  }) => (
    <TextField
      label={label}
      {...custom}
    />
)

export default CustomTextField;


// WEBPACK FOOTER //
// ./src/components/MaterialUi/CustomTextField.js